export const get13DigitCodeForCartAmounts = (productCode: string, priceReference: string) => {
  return productCode + priceReference;
};
export const get15DigitCodeForCartAmounts = (productCode: string, packCode: string, priceReference: string) => {
  return productCode + packCode + priceReference;
};
